// extracted by mini-css-extract-plugin
export default {"productList":"add-return-modal_productList__24CB7","selectorWrapper":"add-return-modal_selectorWrapper__n-VzS"};